import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { MarkdownComponent } from "../markdown/markdown.component";
import { StripHtmlPipe } from '@teamfoster/sdk/text-utility';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./alert.component.scss'],
    imports: [StripHtmlPipe, NgClass, MarkdownComponent]
})
export class AlertComponent {
  status = input<string>('danger');
  title = input<string>();
  message = input<string>();
  html = input<string>();
}
